export const graphcms = {
  endpoint: process.env.GRAPHCMS_PROJECT_ENDPOINT || '',
  token: process.env.GRAPHCMS_PUBLISHED_AUTH_TOKEN || '',
};
